import api from './api';

const handleApiError = (error) => {
  if (error.response) {
    return { 
      status: error.response.status, 
      description: 'API Error' 
    };
  }
  
  if (error.request) {
    return {
      status: -1,
      description: 'The request was made but no response was received',
    };
  }

  console.error('Error:', error.message);
  return {
    status: -2,
    description: 'Something happened in setting up the request that triggered an Error',
  };
};

export const Get = async ({ url }) => {
  try {
    const response = await api.get(url);
    return { data: response.data, status: response.status };
  } catch (error) {
    return handleApiError(error);
  }
};

export const Delete = async ({ url }) => {
  try {
    const response = await api.delete(url);
    return { data: response.data, status: response.status };
  } catch (error) {
    return handleApiError(error);
  }
};

export const Post = async ({ url, data }) => {
  try {
    const response = await api.post(url, data);
    return { data: response.data, status: response.status };
  } catch (error) {
    return handleApiError(error);
  }
};

export const Put = async ({ url, data }) => {
  try {
    const response = await api.put(url, data);
    return { data: response.data, status: response.status };
  } catch (error) {
    return handleApiError(error);
  }
};

export const PostBlob = async ({ url, data }) => {
  try {
    const response = await api.post(url, data, { responseType: 'blob' });
    return { data: response.data, status: response.status };
  } catch (error) {
    return handleApiError(error);
  }
};

export const GetBlob = async ({ url }) => {
  try {
    const response = await api.get(url, { responseType: 'blob' });
    return { data: response.data, status: response.status };
  } catch (error) {
    return handleApiError(error);
  }
};